import { cn } from "@/lib/cn";

/**
 * Subtle chapter progress: a thin rail with one node per chapter. The active
 * node is filled with the brand color; the prior nodes are filled in the
 * foreground neutral; the upcoming nodes are quiet outlines. No numbers.
 *
 * Clicking a node jumps to that chapter — used by hover-revealed controls
 * during live presentation. By default the nodes are decorative only.
 */
export const ProgressDots = ({
  count,
  index,
  onJump,
  className,
  testId,
}) => {
  return (
    <div
      data-testid={testId || "presentation-progress"}
      aria-label={`Chapter ${index + 1} of ${count}`}
      className={cn("flex items-center gap-2", className)}
    >
      {Array.from({ length: count }).map((_, i) => {
        const isActive = i === index;
        const isPast = i < index;
        return (
          <button
            type="button"
            key={i}
            onClick={() => onJump?.(i)}
            data-testid={`progress-dot-${i}`}
            aria-current={isActive ? "step" : undefined}
            aria-label={`Chapter ${i + 1}`}
            className={cn(
              "h-1.5 rounded-full transition-all duration-500 ease-out-expo focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
              isActive && "w-6 bg-brand",
              isPast && "w-1.5 bg-foreground/60 hover:bg-foreground",
              !isActive && !isPast && "w-1.5 bg-border hover:bg-foreground/40"
            )}
          />
        );
      })}
    </div>
  );
};

export default ProgressDots;
